import { rest } from 'msw'
import mockThirdPartyBeneficiaryList from '../../../__mocks__/Beneficiaries/beneficiariesList.json'
import consolidatedBeneficiaries from '../../../__mocks__/Beneficiaries/consolidatedBeneficiaries.json'
import ngnBanks from '../../../__mocks__/Beneficiaries/ngnBankList.json'
import invalidBic from '../../../__mocks__/BicValidation/invalidBic.json'
import invalidIban from '../../../__mocks__/IbanValidation/invalidIban.json'
import validIban from '../../../__mocks__/IbanValidation/validIban.json'
import invalidScan from '../../../__mocks__/ScanValidation/invalidScan.json'
import validScan from '../../../__mocks__/ScanValidation/validScan.json'

export const getThirdPartyBeneficiaryList = rest.get(
  `${API_URL}/api/beneficiaries?size=10&page=0&beneficiary-type=THIRD_PARTY`,
  async (req, res, ctx) => {
    const isOnlyThirdParty = req?.url.toString().includes('&beneficiary-type=THIRD_PARTY')

    return res(
      ctx.json(isOnlyThirdParty ? mockThirdPartyBeneficiaryList : consolidatedBeneficiaries)
    )
  }
)

export const getFirstAndThirdParytBeneficiaryList = rest.get(
  `${API_URL}/api/beneficiaries?size=10&page=0`,
  async (req, res, ctx) => {
    return res(ctx.json(consolidatedBeneficiaries))
  }
)

export const getBeneficiaryListException = rest.get(
  `${API_URL}/api/beneficiaries`,
  async (req, res, ctx) => res(ctx.status(404))
)

export const getBeneficiaryListEmpty = rest.get(
  `${API_URL}/api/beneficiaries`,
  async (req, res, ctx) => res(ctx.json({ content: [] }))
)

const addBeneficiary = rest.post(`${API_URL}/api/beneficiaries`, async (req, res, ctx) =>
  res(ctx.status(200))
)

export const addBeneficiaryException = rest.post(
  `${API_URL}/api/beneficiaries`,
  async (req, res, ctx) => res(ctx.status(500))
)

const deleteBeneficiary = rest.delete(`${API_URL}/api/beneficiaries/*`, async (req, res, ctx) =>
  res(ctx.status(204))
)

export const deleteBeneficiaryException = rest.delete(
  `${API_URL}/api/beneficiaries/*`,
  async (req, res, ctx) => res(ctx.status(500))
)

export const ngnBankList = rest.get(
  `${API_URL}/api/v1/banks?countryCode=NG&currencyCode=NGN`,
  async (req, res, ctx) => res(ctx.json(ngnBanks))
)

export const verifyNgBankAccount = rest.get(
  `${API_URL}/api/v1/bank-accounts/verify`,
  async (req, res, ctx) => res(ctx.json(ngnBanks))
)

export const validIbanResponse = rest.get(
  `${API_URL}/api/banking/bank-accounts/iban?accountNumberFormat=IBAN&accountNumber=GB33BUKB20201555555555`,
  async (req, res, ctx) => res(ctx.json(validIban))
)

export const validScanResponse = rest.get(
  `${API_URL}/api/banking/bank-accounts/scan?sortCode=560029&accountNumber=26207729`,
  async (req, res, ctx) => res(ctx.json(validScan))
)

export const validBicResponse = rest.get(
  `${API_URL}/api/bank/information/validation?bic=NWBKGB2L`,
  async (req, res, ctx) => res(ctx.json('Valid'))
)

export const invalidIbanResponse = rest.get(
  `${API_URL}/api/banking/bank-accounts/iban?accountNumberFormat=IBAN&accountNumber=ZA33BUKB20201555555555`,
  async (req, res, ctx) => res(ctx.json(invalidIban))
)

export const invalidScanResponse = rest.get(
  `${API_URL}/api/banking/bank-accounts/scan?sortCode=560029&accountNumber=11111111`,
  async (req, res, ctx) => res(ctx.json(invalidScan))
)

export const invalidBicResponse = rest.get(
  `${API_URL}/api/bank/information/validation?bic=NWBKGB2`,
  async (req, res, ctx) => res(ctx.json(invalidBic))
)

export default [
  getThirdPartyBeneficiaryList,
  getFirstAndThirdParytBeneficiaryList,
  getBeneficiaryListException,
  getBeneficiaryListEmpty,
  addBeneficiary,
  addBeneficiaryException,
  deleteBeneficiary,
  deleteBeneficiaryException,
]
